import React, { useEffect, useState } from 'react'
import { Button, ButtonGroup, Card, Col, Container, Form, Pagination, Row } from 'react-bootstrap'
import CardBasic from '../../../components/Card/card.basic'
import Select from "react-select";
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import ReportingTable from '../../../components/Table/ReportingTable';
import { AdminService } from '../../../services/admin.service';
import toast from 'react-hot-toast';


const Reporting = () => {
    const [csvData, setCsvData] = useState<any>([]);
    const [tableData, setTableData] = useState<any>();
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(20);
    const [loading, setLoading] = useState<boolean>(false);

    const [startDate, setStartDate] = useState<Date>(moment().subtract(7, "days").toDate());
    const [endDate, setEndDate] = useState<Date>(moment().add(15, 'days').toDate());


    const getReportingData = async () => {
        await AdminService.getReportingData(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"), page, limit, -1).then((res) => {
            if (res.status == 200) {
                setTableData(res.data.reportingData);
            }
        })
            .catch((err) => {
                console.log(err);
            })
    }



    const createCsvFile = async () => {
        setLoading(true);
        await AdminService.getReportingData(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"), page, limit, 1).then((res) => {
            if (res.status == 200) {
                const csvHeader = [
                    "EnrollmentId",
                    "ReceiptId",
                    "Date of purchase",
                    "Instrument",
                    "Teacher",
                    "Student Name",
                    "Student Email",
                    "Student Phone",
                    "Sessions Bought",
                    "Sessions Completed",
                    "Sessions Left",
                    "Sessions Requested",
                    "Expiry Date",
                    "Expiry Status"
                ];

                const csvFinalData = res.data.reportingData.map((data: any) => {
                    return Object.values({
                        "EnrollmentId": data.enrollmentId,
                        "ReceiptId": data.paymentDetailsReceipt,
                        "Date of Purchase": moment(data.dateOfPurchase).format("DD/MM/YYYY"),
                        "Instrument": data.instrument,
                        "Teacher": data.instructorName,
                        "Student Name": data.studentName,
                        "Student Email": data.studentEmail,
                        "Student Phone": data.studentPhone,
                        "Sessions Bought": data.totalClasses,
                        "Sessions Completed": data.classesCompleted,
                        "Sessions Left": data.classesLeft,
                        "Sessions Requested": data.classesRequested,
                        "Expiry Date":moment(data.validityDate).format("DD/MM/YYYY"),
                        "Expiry Status": data.expiryStatus,
                    });
                })

                const csvDataWithHeader = [csvHeader];
                if (csvFinalData && csvFinalData.length > -0) {
                    csvDataWithHeader.push(...csvFinalData);
                }

                setCsvData(csvDataWithHeader);
                setLoading(false);
            }
        })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                toast.error("Unable to fetch Payment Details");
            })
    }

    useEffect(() => {
        if (startDate && endDate) {
            getReportingData();
        }
    }, [page, limit, startDate, endDate]);

    return (
        <>
            <Container>
                <Row>
                    <Col>
                        <CardBasic
                            className="mt-3"
                            body={
                                <>
                                    <h6>Filters</h6>
                                    <Row>
                                        <Col md={3}>
                                            <Form.Label className="fw-bold text-secondary fs-12">
                                                Start Date
                                            </Form.Label>
                                            <ReactDatePicker
                                                onChange={(e: any) => {
                                                    setStartDate(e);
                                                }}
                                                selected={startDate}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                            />
                                        </Col>

                                         <Col md={3}>
                                            <Form.Label className="fw-bold text-secondary fs-12">
                                                End Date
                                            </Form.Label>
                                            <ReactDatePicker
                                                onChange={(e: any) => {
                                                    setEndDate(e);
                                                }}
                                                selected={endDate}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                            />
                                        </Col>
                                    </Row>
                                </>
                            }
                        />
                    </Col>
                </Row>
                <Card className='mt-4'>
                    <Card.Body>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <Card.Title>Enrollment Expiry Report</Card.Title>
                            <div className="d-flex gap-2 ">
                                <ButtonGroup size="sm">
                                    <Button size='sm' className="me-1" onClick={() => { createCsvFile() }} disabled={loading?true:false}>
                                        {loading ? "Please wait" : "Create CSV Data"}
                                    </Button>
                                    {csvData && csvData.length > 0 && <CSVLink data={csvData} filename={"enrollment.csv"}>
                                        <Button>Download CSV</Button>
                                    </CSVLink>}
                                </ButtonGroup>
                            </div>
                        </div>
                        <div className='m-4'>
                            <ReportingTable
                                tableData={tableData}
                                reloadData={getReportingData}
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Pagination>
                                <Pagination.First />
                                <Pagination.Prev
                                    onClick={() => {
                                        setPage(page - 1);
                                    }}
                                />
                                <Pagination.Item>{page}</Pagination.Item>
                                <Pagination.Next
                                    onClick={() => {
                                        setPage(page + 1);
                                    }}
                                />
                                <Pagination.Last />
                            </Pagination>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
}

export default Reporting